import React, { useEffect, useState } from "react";
import { buildSummaryRowsFromAnalysis } from '../utils/buildSummaryRows';
import { useLanguage } from '../i18n';
import { highlightPenetrationPhrases } from '../utils/highlightPenetrationPhrases';

// Ikoner (bock, kryss)
const Check = () => <span style={{color:'#279e40',fontSize:'1.3em'}}>&#x2714;</span>;
const Cross = () => <span style={{color:'#d80a0a',fontSize:'1.3em'}}>&#x2718;</span>;

export default function ResultatTable({ geometries, analysis, omniAnalysis, oasAnalysis, baroVnavAnalysis, vssAnalysis, shieldingAnalysis, holdingBaseAnalysis, holdingRacetrackAnalysis, rnavHoldingAnalysis, rnpHoldingAnalysis, msaAnalysis, taaAnalysis, circlingAnalysis, gnssApchAnalysis, locAnalysis, onSummaryRows }) {
  const { t } = useLanguage();
  const [analysdata, setAnalysdata] = useState([]);
  const [summaryRows, setSummaryRows] = useState([]);

  useEffect(() => {
    if (!analysis || !Array.isArray(analysis) || analysis.length === 0) {
      setAnalysdata([]);
      setSummaryRows([]);
      if (onSummaryRows) onSummaryRows([]);
      return;
    }

    // Bygg tabellrader från redan beräknad analys, inkludera OMNI om tillgängligt
    const rows = buildSummaryRowsFromAnalysis(analysis, "html", t, omniAnalysis, oasAnalysis, baroVnavAnalysis, vssAnalysis, shieldingAnalysis, holdingBaseAnalysis, holdingRacetrackAnalysis, rnavHoldingAnalysis, rnpHoldingAnalysis, msaAnalysis, taaAnalysis, circlingAnalysis, gnssApchAnalysis, locAnalysis);
    
    setAnalysdata(rows);
    setSummaryRows(rows);
    if (onSummaryRows) onSummaryRows(rows);
  }, [analysis, omniAnalysis, oasAnalysis, baroVnavAnalysis, vssAnalysis, shieldingAnalysis, holdingBaseAnalysis, holdingRacetrackAnalysis, rnavHoldingAnalysis, rnpHoldingAnalysis, msaAnalysis, taaAnalysis, circlingAnalysis, gnssApchAnalysis, locAnalysis, onSummaryRows, t]);

  if (!geometries || geometries.length === 0) {
    return <div>{t("noGeometriesToAnalyze")}</div>;
  }

  if (!analysis || !Array.isArray(analysis) || analysis.length === 0) {
    return <div>{t("noAnalysisToShow")}</div>;
  }

  return (
    <div>
      <h2>{t("result")}</h2>
      <style>
        {`
        .analys-table {
          width: 100%;
          border-collapse: collapse;
          background: #fff;
          margin-top: 1em;
          font-family: 'Segoe UI', Arial, sans-serif;
        }
        .analys-table th, .analys-table td {
          border: 1px solid #bbb;
          padding: 10px 8px;
        }
        .analys-table th {
          background: #f5f5f5;
          font-weight: 600;
          font-size: 1.1em;
        }
        .omni-impact-flag {
          color: #d80a0a;
          font-weight: bold;
        }
        .omni-no-impact-flag {
          color: #009600;
          font-weight: bold;
        }
        `}
      </style>
      <table className="analys-table">
        <thead>
          <tr>
            <th>{t("object")}</th>
            <th>{t("analysis")}</th>
            <th>{t("withinSurfaceYes")}</th>
            <th>{t("withinSurfaceNo")}</th>
            <th>{t("comment")}</th>
            <th style={{color:"#279e40"}}>{t("withoutNotification")}</th>
            <th style={{color:"#d80a0a"}}>{t("withNotification")}</th>
          </tr>
        </thead>
        <tbody>
          {analysdata.map((row, i) => (
            <tr key={i}>
              <td style={{textAlign:"left", fontWeight: 500}}>{row[0]}</td>
              <td style={{textAlign:"left"}}>{row[1]}</td>
              <td style={{textAlign:"center"}}>{(row[2] === "JA" || row[2] === "YES") ? <Check/> : ""}</td>
              <td style={{textAlign:"center"}}>{(row[3] === "NEJ" || row[3] === "NO") ? <Check/> : ""}</td>
              <td style={{textAlign:"left"}}>{highlightPenetrationPhrases(row[4], t)}</td>
              <td style={{textAlign:"center"}}>{(row[5] === "JA" || row[5] === "YES") ? <Check/> : ""}</td>
              <td style={{textAlign:"center"}}>{(row[6] === "NEJ" || row[6] === "NO") ? <Cross/> : ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ fontSize: "0.95em", color: "#444", marginTop: 14 }}>
        <b>{t("tip")}:</b> {t("pdfReportTip")}
      </div>
    </div>
  );
}